import React from 'react'
import styled from 'styled-components'

import ClientLayout from 'spa/client/layouts/ClientLayout'
import { mixinTitle, mixinMainContainer } from 'spa/client/styles/mixin'

const StyledTitle = styled.h1`
  ${mixinTitle}
`

const StyledMainContainer = styled.div`
  ${mixinMainContainer}
  padding-left: 20px;
`

export const StyledClientContractExtensionRequestsSubmitted: React.FC = () => {
  return (
    <ClientLayout>
      <StyledTitle>契約更新の確認</StyledTitle>
      <StyledMainContainer>
        <p>ご回答ありがとうございました。</p>
      </StyledMainContainer>
    </ClientLayout>
  )
}
